<template>
  <div class="mt-20">
    <div class="flex flex-col h-screen z-10 my-3 w-full">
      <div class="flex flex-col text-2xl lg:text-3xl justify-start mb-3
      text-white items-center uppercase tracking-wider">
          Masterclasses
      </div>
      <div class="flex flex-wrap flex-col md:flex-row bg-white h-screen w-screen blur py-10
        overscroll-auto">
        <div v-if="masterclasses == 0" class="text-black flex justify-center w-full">
          No masterclasses yet.</div>
        <masterclass-card v-for="masterclass in masterclasses"
        :key="masterclass.id" :masterclass="masterclass"
        class="w-3/4 mx-auto mb-20 z-10" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import MasterclassCard from '../components/masterclasses/MasterclassCard.vue';
// import SoundWave from '../components/graphics/SoundWave.vue';

export default {
  components: {
    MasterclassCard,
  },

  data() {
    return {
      masterclasses: [],
    };
  },

  created() {
    this.getMasterclasses();
  },

  methods: {
    getMasterclasses() {
      axios.get('/api/masterclasses').then(({ data }) => {
        this.masterclasses = data;
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },
  },
};
</script>

<style scoped>
  .blur{
    background: rgb(255, 255, 255, 0.8);
    box-shadow: 0 3px 20px 0 rgba(92, 92, 92, 0.842);
    backdrop-filter: blur( 3.0px );
    -webkit-backdrop-filter: blur( 3.0px );
  }
</style>
